<template>
	<Component
		:is="decideComponent"
		:class="variantCls.root"
		:href="href"
		:to="to"
		:target="target"
		:disabled="disabled"
		tabindex="0"
		v-on="$listeners"
	>
		<slot></slot>
	</Component>
</template>

<script>
export default {
	props: {
		variant: {
			type: String,
			default: "default"
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false
		},
		to: {
			type: [String, Object],
			required: false
		},
		href: {
			type: String,
			required: false
		},
		target: {
			type: String,
			default: "_self",
			required: false
		},
		routerTag: {
			type: String,
			required: false,
			default: "router-link"
		}
	},
	computed: {
		variantCls() {
			return this.$store.getters.variants("JButton", this.variant).el
		},

		decideComponent() {
			if (this.href) return "a"
			if (this.to) return this.routerTag
			return "button"
		}
	}
}
</script>
